import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
//shared stores
import * as testTypeStore from '@/store/shared-stores/testTypeStore';
import * as doctorOptionsStore from '@/store/shared-stores/doctorOptionsStore';
import * as accountSearchStore from '@/components/AccountSearchComponent/store/accountSearchStore.js';

//Page stores
import { routesData } from '../../dashboard-config/routes-config.js';
const customComponentStores = routesData.reduce((prev, route) => {
  if (route.store) {
    prev[route.store] = require(`@/views/${route.name}/store/${route.store}.js`);
  }
  return prev;
}, {});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    testTypeStore,
    doctorOptionsStore,
    accountSearchStore,
    ...customComponentStores
  },
  state,
  getters,
  mutations,
  actions
});
